import { useCallback } from "react";

import type {
  FlightSearchPagedResultData,
  FlightSearchParams,
} from "@/features/flights/hooks/flightSearch/types";
import { isPackageBanner } from "@/features/flights/hooks/flightSearch/utils";
import type { IFlightFilters } from "@/types/interfaces";
import type { FlightSearchType } from "@/types/types";

import { useFlightSearch } from "./useFlightsSearch";

export const useDepartureFlightSearch = (
  params: FlightSearchParams,
  filters: IFlightFilters | null,
  searchType?: FlightSearchType | null,
) => {
  const select = useCallback((response: FlightSearchPagedResultData) => {
    // For now, we're limiting number of banners to be displayed
    const bannerLimit = 1;

    const allOffers = response.pages.flatMap((page) => page.offers);

    let bannerCount = 0;
    return allOffers.filter((offer) => {
      if (isPackageBanner(offer)) {
        if (bannerCount < bannerLimit) {
          bannerCount++;
          return true;
        }
        return false;
      }
      // Keep all flight offers
      return true;
    });
  }, []);

  const query = useFlightSearch(params, filters, { select }, searchType);

  const hasReachedEnd = !query.hasNextPage;
  const isEmpty = !query.result || query.result.length === 0;

  return {
    ...query,
    hasReachedEnd,
    isEmpty,
  };
};
